import { ResponseStatus } from 'src/app/hickory-api';

export function getPage<T>(list: Array<T>, page: number = 1, pageSize: number = 25): Paged<T> {
  if (!list) {
    return getEmptyPage<T>(page, pageSize);
  }
  const pageIndex = (page - 1) * pageSize;
  return {
    status: { isSuccess: true },
    hasErrors: false,
    isValid: true,
    page: page,
    pageCount: list.length / pageSize,
    pageSize: pageSize,
    totalItemCount: list.length,
    items: list.filter((t, idx) => idx >= pageIndex && idx < pageIndex + pageSize)
  };
}

export function getEmptyPage<T>(page: number = 1, pageSize: number = 25) {
  return {
    status: { isSuccess: true },
    hasErrors: false,
    isValid: true,
    page: page,
    pageCount: 0,
    pageSize: pageSize,
    totalItemCount: 0,
    items: new Array<T>()
  };
}

export interface Paged<T> {
  status?: ResponseStatus;
  hasErrors?: boolean;
  isValid?: boolean;
  page?: number;
  pageCount?: number;
  pageSize?: number;
  totalItemCount?: number;
  items?: Array<T>;
}
